export default __webpack_public_path__ + "static/media/logoUboussole.6596148e.svg";